function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { ChartBar } from '../';
import Color from 'color';

class ChartBarGrouped extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getColors", () => {
      const theme = this.props.theme;
      return [theme.primaryColor || "black", "#ccc"];
    });
  }

  render() {
    const colors = this.getColors();
    return React.createElement(ChartBar, _extends({}, this.props, {
      colors: colors
    }));
  }

}

_defineProperty(ChartBarGrouped, "defaultProps", {
  groupMode: "grouped"
});

export default ChartBarGrouped;